import { useContext } from "react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import {
  GPS_DOCUMENT_LINKS_FLAG,
  isGpsDocumentLinksAccount,
} from "@/lib/gpsDocumentLinks"
import { XmppContext } from "@/stream/xmppClient"

/** The report is shown for wizard-linked and GPS-linked accounts; GPS is read-only. */
export const useCmrReportMode = () => {
  const { myJid } = useContext(XmppContext)
  const manual = Boolean(useFeatureFlagEnabled("cmr-delivery-link"))
  const gpsFlag = useFeatureFlagEnabled(GPS_DOCUMENT_LINKS_FLAG)
  const readOnly = isGpsDocumentLinksAccount(myJid?.getDomain(), gpsFlag)
  return { enabled: manual || readOnly, readOnly }
}
